import {
  useProduct,
  useSelectedVariant,
  useSelectionActions
} from '@/components/product/product-context';
import { buildOptionChoices } from '@/components/product/utils/product-context-helpers';

/**
 * Everything a dropdown or button grid needs to render one option: the values
 * that resolve to a real variant against the current selection, the value
 * currently picked, and the change handler.
 *
 * Reads the selected variant and the selection actions, so it can only be
 * called inside a Suspense boundary.
 */
export function useOptionChoices(optionName, optionValues) {
  const { productData } = useProduct();
  const { selectedOptions } = useSelectedVariant();
  const { updateOption } = useSelectionActions();

  return {
    choices: buildOptionChoices({
      shopifyProduct: productData?.shopifyProduct,
      selectedOptions,
      optionName,
      optionValues
    }),
    value: selectedOptions?.[optionName],
    onChange: (e) => updateOption({ [optionName]: e.target.value })
  };
}
